module.exports = __webpack_public_path__ + "img/infight4.1fa81da6.jpg";